import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { toastError, toastSuccess, toastWarning } from '@components/Toast';
import useDealSplitPrompt, { dealSplitQuery } from '@components/modals/useDealSplitPrompt';

import OrderSummeryReport from '@features/order/OrderSummeryReport';
import RequestConfirmation from '@features/order-cancel/RequestConfirmation';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { fetchOrderDetailsInfo } from '@store/orders/actions';
import { getOrderDetailsInfo, getOrderPlaceWorkflow } from '@store/reducers';

import { sendOrderToShipmentByOrderId, startOrderByOrderId } from '@services/commonService';

import ApiClient from '@lib/apiClient';

import { checkUserType, downloadBlobFIle } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

const ReportOption = ({ projectStatus, orderStatus }) => {
	const [openSummeryReport, setOpenSummeryReport] = useState(false);
	const [openOrderCancelModal, setOpenOrderCancelModal] = useState(false);
	const [isSupplierAssigned, setIsSupplierAssigned] = useState(false);
	const orderPlaceMentStatus = useSelector(getOrderPlaceWorkflow);
	let orderDetailsInfo = useSelector(getOrderDetailsInfo);
	const dispatch = useDispatch();
	const { askDealSplit, dealSplitModal } = useDealSplitPrompt();
	const { id } = useParams();

	useEffect(() => {
		let supplierWorkflowStep = orderPlaceMentStatus?.find((item) => item.workflowStep === 'SUPPLIER');
		if (supplierWorkflowStep?.status === 'COMPLETED') {
			setIsSupplierAssigned(true);
		} else {
			setIsSupplierAssigned(false);
		}
	}, [orderPlaceMentStatus]);

	const downloadPoDetails = () => {
		dispatch(openLoader());
		ApiClient.GET_FILE_DATA(`${BASE_URL}/order/${id}/details/download`, '', true)
			.then((response) => {
				downloadBlobFIle(response);
				dispatch(closeLoader());
			})
			.catch((error) => {
				toastError(error.response.data.message);
				dispatch(closeLoader());
			});
	};

	const onDownload = async () => {
		dispatch(openLoader());
		await ApiClient.GET_FILE_DATA('downloadOrderDashboardReports', `?orderIdList=${id}`)
			.then((response) => {
				downloadBlobFIle(response);
				dispatch(closeLoader());
			})
			.catch(() => {
				dispatch(closeLoader());
			});
	};

	const startOrder = async () => {
		try {
			dispatch(openLoader());
			await startOrderByOrderId(id);
			await dispatch(fetchOrderDetailsInfo(id));
			dispatch(closeLoader());
		} catch (error) {
			toastWarning(error?.response?.data?.message || 'Something went wrong! Please try again.');
			dispatch(closeLoader());
		}
	};

	const sendOrderToShipment = async () => {
		try {
			dispatch(openLoader());
			await sendOrderToShipmentByOrderId(id);
			await dispatch(fetchOrderDetailsInfo(id));
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const syncData = async () => {
		const splitDealIds = await askDealSplit(id);
		if (splitDealIds === null) return;

		dispatch(openLoader());
		await ApiClient.POST('syncData', {}, id + '/sync' + dealSplitQuery(splitDealIds))
			.then(() => {
				dispatch(closeLoader());
				toastSuccess('Updated Successfully');
			})
			.catch((error) => {
				dispatch(closeLoader());
				toastError(error.response.data.message);
			});
	};

	return (
		<>
			{dealSplitModal}
			<div className="dropdown-report d-inline">
				<button
					className="btn btn-outline-secondary dropdown-toggle ml-0  pl-1"
					type="button"
					data-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="false"
				>
					<span className="regular-12">More</span>

					<img src={`${process.env.PUBLIC_URL}/icons/arrow_drop_up.svg`} alt="arrow" />
				</button>
				<div className="dropdown-menu dropdown-menu-right">
					<span className="dropdown-item cursor-pointer no-hover">Download</span>
					<hr />
					{/*<a className="dropdown-item cursor-pointer" onClick={() => setOpenSummeryReport(true)}>*/}
					{/*	Order margin*/}
					{/*</a>*/}
					<a className="dropdown-item cursor-pointer" onClick={downloadPoDetails}>
						PO details
					</a>
					{projectStatus !== 'PENDING' && (
						<a className="dropdown-item cursor-pointer" onClick={onDownload}>
							TNA Summary
						</a>
					)}
					<hr />
					{orderStatus === 'PENDING' &&
						isSupplierAssigned &&
						(orderDetailsInfo?.stream === 'STREAM_THREE' ||
							orderDetailsInfo?.isShortDelivery) && (
							<a className="dropdown-item cursor-pointer" onClick={startOrder}>
								Start Order
							</a>
						)}
					{orderStatus === 'RUNNING' &&
						(orderDetailsInfo?.stream === 'STREAM_THREE' ||
							orderDetailsInfo?.isShortDelivery) && (
							<a className="dropdown-item cursor-pointer" onClick={sendOrderToShipment}>
								Send to Shipment
							</a>
						)}
					{checkUserType('ADMIN') &&
						(orderStatus === 'RUNNING' ||
							orderStatus === 'PENDING' ||
							orderStatus === 'ON_SHIPMENT' ||
							orderStatus === 'COMPLETED') && (
							<span className="dropdown-item cursor-pointer" onClick={syncData}>
								Sync Data
							</span>
						)}

					{orderStatus !== 'ON_SHIPMENT' && orderStatus !== 'COMPLETED' && (
						<span
							className="dropdown-item cursor-pointer red"
							onClick={() => setOpenOrderCancelModal(true)}
						>
							Cancel Order
						</span>
					)}
				</div>
			</div>
			{openSummeryReport && (
				<OrderSummeryReport
					show={openSummeryReport}
					handleClose={() => setOpenSummeryReport(false)}
				/>
			)}
			{openOrderCancelModal && (
				<RequestConfirmation onCloseModal={() => setOpenOrderCancelModal(false)} />
			)}
		</>
	);
};

export default ReportOption;
